import { useQuery } from "react-query";
import { QueryReturnType } from "../../services/networking.service";
import ENDPOINTS from "../../services/endPoints";

export interface AuthAuditStatsFilters {
  from?: string;
  to?: string;
}

export const useGetAuthAuditStats = (
  filters: AuthAuditStatsFilters = {},
  enabled: boolean = true
): QueryReturnType<any> => {
  return useQuery<never, never, any>(
    [ENDPOINTS.AUTH_AUDIT_LOGS_STATS, filters],
    {
      enabled,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );
};
